import React from "react";
import Skeleton from "@mui/material/Skeleton";

import styles from "./sharedCartReviewSkeleton.module.scss";
import { sp, br } from "../../../../styles/design-tokens";

const sk = (props: any) => <Skeleton animation="wave" variant="rectangular" {...props} />;

/**
 * Full-page review skeleton shown while a shared cart (?sharedCartId=) is being
 * loaded — App renders this whenever `sharedCartLoading` is true. Mirrors the
 * review layout (a flight card, a stays card, an activities card, and the price
 * sidebar) so the recipient lands on a review-shaped loading state. Once the
 * snapshot is reconstructed into the cart, App swaps to the real review page.
 */
function ReviewCardSkeleton({ title }: { title: string }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        {sk({ width: 24, height: 24, sx: { borderRadius: br(6) } })}
        <span className={styles.cardTitle}>{title}</span>
      </div>
      {sk({ width: "100%", height: 96, sx: { borderRadius: br(8) } })}
      <div className={styles.row}>
        {sk({ width: "40%", height: 14, sx: { borderRadius: br(4) } })}
        {sk({ width: "20%", height: 14, sx: { borderRadius: br(4) } })}
      </div>
      {sk({ width: "60%", height: 14, sx: { borderRadius: br(4) } })}
    </div>
  );
}

export default function SharedCartReviewSkeleton() {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <ReviewCardSkeleton title="Flights" />
        <ReviewCardSkeleton title="Stays" />
        <ReviewCardSkeleton title="Activities" />
      </div>
      <aside className={styles.sidebar}>
        <div className={styles.stepper}>
          {sk({ width: 24, height: 24, sx: { borderRadius: "50%" } })}
          {sk({ width: 24, height: 24, sx: { borderRadius: "50%" } })}
          {sk({ width: 24, height: 24, sx: { borderRadius: "50%" } })}
        </div>
        {sk({ width: "70%", height: 16, sx: { borderRadius: br(4), marginTop: sp(16) } })}
        <div className={styles.priceRow}>
          {sk({ width: "45%", height: 18, sx: { borderRadius: br(4) } })}
          {sk({ width: "25%", height: 18, sx: { borderRadius: br(4) } })}
        </div>
        <div className={styles.priceRow}>
          {sk({ width: "30%", height: 22, sx: { borderRadius: br(4) } })}
          {sk({ width: "30%", height: 22, sx: { borderRadius: br(4) } })}
        </div>
        {sk({ width: "100%", height: 48, sx: { borderRadius: br(24), marginTop: sp(20) } })}
      </aside>
    </div>
  );
}
